module.exports = __webpack_public_path__ + "static/media/step1-sell.d11196fd.svg";